class CompanyInfo {
  catchupAmount = 1000;
  catchupAge = 55;

  familyHsaLimit (year: number, age: number): string {
    const catchupAmount = age >= this.catchupAge ? this.catchupAmount : 0;

    switch (year) {
      case 2021:
        return `${7200 + catchupAmount}`;
      case 2022:
        return `${7300 + catchupAmount}`;
      case 2023:
        return `${7750 + catchupAmount}`;
      case 2024:
        return `${8300 + catchupAmount}`;
      default:
        return `${7200 + catchupAmount}`;
    }
  }

  individualHsaLimit (year: number, age: number): string {
    const catchupAmount = age >= this.catchupAge ? this.catchupAmount : 0;

    switch (year) {
      case 2021:
        return `${3600 + catchupAmount}`;
      case 2022:
        return `${3650 + catchupAmount}`;
      case 2023:
        return `${3850 + catchupAmount}`;
      case 2024:
        return `${4150 + catchupAmount}`;
      default:
        return `${3600 + catchupAmount}`;
    }
  }
}

export default (new CompanyInfo());